import { render, staticRenderFns } from "./VendasMesesdoAnoFatVolume.vue?vue&type=template&id=d89f2ffe&scoped=true&"
import script from "./VendasMesesdoAnoFatVolume.vue?vue&type=script&lang=js&"
export * from "./VendasMesesdoAnoFatVolume.vue?vue&type=script&lang=js&"
import style0 from "./VendasMesesdoAnoFatVolume.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./VendasMesesdoAnoFatVolume.vue?vue&type=style&index=1&id=d89f2ffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89f2ffe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VContainer,VIcon,VRadio,VRadioGroup,VRow})
